import { useCallback } from 'react';
import { useAppScopeStore } from '@frontend/scope';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { useInsurancePayerConnectionShallowStore } from '../stores/use-insurance-payer-connection-store';

type NavigatePayload = {
  payerId?: string;
  payerWebsiteId?: string;
  webSupported?: boolean;
};

/**
 * Shared navigation hook to open the Payer Connection Management settings page
 * with the correct payer / website preselected.
 */
export const useNavigateToPayerConnectionManagement = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { navigate } = useSettingsNavigate();
  const locationId = selectedLocationIds[0] ?? '';

  const { setPayerConnectionTab, setPayerConnectionPayerID, setPayerConnectionPayerWebsiteID } =
    useInsurancePayerConnectionShallowStore(
      'setPayerConnectionTab',
      'setPayerConnectionPayerID',
      'setPayerConnectionPayerWebsiteID'
    );

  return useCallback(
    (payload?: NavigatePayload) => {
      const { payerId, payerWebsiteId, webSupported } = payload ?? {};

      if (payerId) {
        setPayerConnectionPayerID(payerId);
      }

      if (payerWebsiteId) {
        setPayerConnectionPayerWebsiteID(payerWebsiteId);
      }

      setPayerConnectionTab(webSupported ? 'websites' : '');

      if (locationId) {
        navigate({ to: '/insurance/payer-connection-management/:locationId', params: { locationId } });
        return;
      }

      navigate({ to: '/insurance/payer-connection-management' });
    },
    [locationId, navigate, setPayerConnectionPayerID, setPayerConnectionPayerWebsiteID, setPayerConnectionTab]
  );
};
